import { Message } from 'element-ui';
import * as types from '../mutation-types';
import { getSuppliers } from '../../services/purchase-orders';
import { createSupplier } from '../../services/suppliers';

const state = {
  suppliers: [],
};

const getters = {
  getSuppliers: state => state.suppliers,
};

const mutations = {
  [types.SET_SUPPLIERS](state, suppliersArr) {
    state.suppliers = suppliersArr;
  },
};

const actions = {
  setSuppliers({ commit }) {
    const suppliersList = [];
    const getSuppliersAllPages = (page = '') => {
      getSuppliers(page)
        .then(response => response.data)
        .then((data) => {
          if (data.pagination.nextPage) {
            suppliersList.push(...data.results);
            getSuppliersAllPages(`?page=${data.pagination.nextPage}`);
          } else {
            suppliersList.push(...data.results);
            commit(types.SET_SUPPLIERS, suppliersList);
          }
        })
        .catch((error) => {
          if (error.response.data.message) {
            Message.error(error.response.data.message);
          } else {
            Message.error('Something went wrong! Try again.');
          }
        });
    };
    getSuppliersAllPages();
  },
  createNewSupplier({ dispatch }, supplier) {
    createSupplier(supplier)
      .then(() => {
        Message.success('Success! Supplier created!');
        dispatch.setSuppliers();
        dispatch('setNewReceivableModalVisibility', false);
      })
      .catch(() => {
        Message.warning('Something went wrong!');
      });
  },
};
export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/suppliers.js